import {handleSend} from '../handleSend'
import {ConsumeApi} from './consume_api'

export const ReportApi = {
  // 获取终端号下拉框
  getPosNoList (id = '') {
    let data = {merchid: id}
    return ConsumeApi.consumeDropDownList('004', data)
  },
  // 终端交易日报表
  queryReportOfMachineDealDay (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0001', String(type), 'message')
  },
  // 终端交易汇总报表
  queryReportOfMachineDealTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0002', String(type), 'message')
  },
  // 商户清算日报表
  queryReportOfMerchantDay (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0003', String(type), 'message')
  },
  // 商户清算汇总报表
  queryReportOfMerchantTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0004', String(type), 'message')
  },
  // 终端工作时段日报表
  queryReportOfMachineWorkDay (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0005', String(type), 'message')
  },
  // 终端工作时段汇总报表
  queryReportOfMachineWorkTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0006', String(type), 'message')
  },
  // 商户工作时段汇总报表
  queryReportOfMerchantWorkTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0007', String(type), 'message')
  },
  // 充值统计报表
  queryReportOfRecharge (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0008', String(type), 'message')
  },
  // 应用账户余额报表
  queryReportOfAccountBalance (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0009', String(type), 'message')
  },
  // 应收应付明细报表
  queryReportOfReceivable (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0010', String(type), 'message')
  },
  // 应收应付汇总报表
  queryReportOfReceivableTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0011', String(type), 'message')
  },
  // 个人优惠明细报表
  queryReportOfPersonalDiscount (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0012', String(type), 'message')
  },
  // 个人优惠汇总报表
  queryReportOfPersonalDiscountTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0013', String(type), 'message')
  },
  // 优惠汇总报表
  queryReportOfDiscountTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0014', String(type), 'message')
  },
  // 计次消费统计报表
  queryCountConsume (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0015', String(type), 'message')
  },
  // 商户订餐清算汇总报表
  queryReportOfMerchantOrderTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0017', String(type), 'message')
  },
  // 商户时段日报表
  queryReportOfMerchantWorkDay (data, type = 0) {
    return handleSend(data, '49', '0018', String(type), 'message')
  },
  // 扫码消费明细报表
  queryReportOfScanCodeCosum (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0020', String(type), 'message')
  },
  // 差错账报表
  queryReportOfErrorAccounting (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0021', String(type), 'message')
  },
  // 餐次窗口消费统计报表
  queryReportOfMealsWindowConsum (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0022', String(type), 'message')
  },
  // 窗口消费统计报表
  queryReportOfWindowConsum (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0023', String(type), 'message')
  },
  // 账务结算报表
  queryReportOfFinanceSettle (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0024', String(type), 'message')
  },
  // 系统月度对账单报表
  queryReportOfMonthStatement (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0025', String(type), 'message')
  },
  // 充值明细报表
  queryReportOfRechargeDetails (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0026', String(type), 'message')
  },
  // 扫码消费汇总报表
  queryReportOfScanCodeTotal (data, type = 0) {
    return handleSend(data, '49', '0027', String(type), 'message')
  },
  // 被扫交易流水
  queryReportOfScanDetails (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '3001', String(type), 'message')
  },
  returnScanDetails (data) {
    return handleSend(data, '45', '3002')
  },
  // 被扫交易统计
  queryReportOfScanTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0016', String(type), 'message')
  },
  // 收入明细表接口（49,0028
  queryReportOfIncomeDetail (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0028', String(type), 'message')
  },
  // 人员消费汇总接口（49,0029
  queryReportOfPersonConsumeTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0029', String(type), 'message')
  },
  // 部门时段消费汇总接口（49,0030
  queryReportOfDeptConsumeTotal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0030', String(type), 'message')
  },
  // 消费时段日报表接口（49,0031
  queryReportOfConsumeDay (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0031', String(type), 'message')
  },
  // 水牌时段日报表接口（49,0019
  queryReportOfNhqrpayWorkDay (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0019', String(type), 'message')
  },
  // 部门餐次汇总日报表（49,0033
  queryReportOfDeptDayConsumeTotal (data, type = 0) {
    return handleSend(data, '49', '0033', String(type), 'message')
  }
}



// WEBPACK FOOTER //
// ./src/request/Consume/report_api.js